import xss from 'xss';
import type { IFilterXSSOptions } from 'xss';
import { defineNuxtPlugin } from '#imports';

const defaultXssOptions: IFilterXSSOptions = {
  onIgnoreTagAttr: function (tag, name, value, isWhiteAttr) {
    if (name.startsWith('data-') || name.startsWith('style') || name.startsWith('class')) {
      // escape its value using built-in escapeAttrValue function
      return name + '="' + value + '"';
    }
  },
};

export default defineNuxtPlugin(nuxtApp => {
  Object.defineProperty(nuxtApp.vueApp.config.globalProperties, '$xss', {
    value: function (html: string) {
      return xss(html, defaultXssOptions);
    },
  });
});
